import type { FC, PropsWithChildren, ReactElement, ReactNode } from 'react';
import Section from '@components/Section/Section';
import { observer } from 'mobx-react';
import { ReviewIcon } from '../assets/icons/instruction/Review';
import { NewsIcon } from '../assets/icons/instruction/NewsIcon';
import { OrderStatusIcon } from '../assets/icons/instruction/OrderStatusIcon';
import { PaymentIcon } from '../assets/icons/instruction/PaymentIcon';
import { OrderConfirmIcon } from '../assets/icons/instruction/OrderConfirmIcon';

import Overview from '../assets/images/instruction/overview.png';
import OrderTotal2 from '../assets/images/instruction/OrderTotal2.png';
import Confirm3 from '../assets/images/instruction/Confirm3.png';
import Confirm4 from '../assets/images/instruction/Confirm4.png';
import Confirm5 from '../assets/images/instruction/Confirm5.png';
import Total6 from '../assets/images/instruction/Total6.png';
import Details7 from '../assets/images/instruction/Details7.png';
import Status8 from '../assets/images/instruction/Status8.png';
import Status10 from '../assets/images/instruction/Status10.png';
import Review11 from '../assets/images/instruction/Review11.png';
import Promotions12 from '../assets/images/instruction/Promotions12.png';
import Barcode from '../assets/images/instruction/Barcode.png';
import Language from '../assets/images/instruction/Language.png';
import Questions from '../assets/images/instruction/Questions.png';
import { twMerge } from 'tailwind-merge';

interface ISectionProps {
    topMargin?: string;
    children?: ReactNode;
}

const SectionLight: FC<ISectionProps> = ({ topMargin = 'mt-10', children }): ReactElement => (
    <section className={twMerge('mx-[1rem] lg:mx-[10rem]', topMargin)}>
        <div className="flex flex-col mx-auto max-w-[1280px] px-[1rem] lg:px-[10rem]">
            {children}
        </div>
    </section>
);

const SectionDark: FC<PropsWithChildren> = ({ children }): ReactElement => (
    <section className="bg-stone-50 mt-10 py-10">
        <div className="mx-[1rem] lg:mx-[10rem]">
            <div className="flex flex-col justify-center h-full mx-auto max-w-[1280px] px-[1rem] lg:px-[10rem]">
                {children}
            </div>
        </div>
    </section>
);

const MainPage = () => (
    <Section withContainer={false}>
        <SectionLight topMargin={''}>
            <h1 className="text-gray-800 text-xl lg:text-3xl font-semibold leading-[58px]">Ссылка на заказ</h1>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-[32px]">это удобная альтернатива и дополнение к Личному кабинету</div>
        </SectionLight>

        <SectionLight>
            <div className="text-gray-800 text-lg lg:text-xl font-semibold leading-[40px]">C помощью ссылки на заказ можно удалённо:</div>
            <div className="flex flex-col lg:flex-row items-center mt-6 gap-8">
                <div className="flex flex-col w-[200px] h-[264px] bg-white rounded-lg shadow items-center justify-center">
                    <OrderConfirmIcon />
                    <div className="text-center text-gray-800 text-[15px] font-semibold leading-[27px] tracking-wide mt-2">Получать подтверждение <br />по заказу</div>
                </div>
                <div className="flex flex-col w-[200px] h-[264px] bg-white rounded-lg shadow items-center justify-center">
                    <PaymentIcon />
                    <div className="text-center text-gray-800 text-[15px] font-semibold leading-[27px] tracking-wide mt-2">Оплачивать заказ картой, бонусами или депозитом</div>
                </div>
                <div className="flex flex-col w-[200px] h-[264px] bg-white rounded-lg shadow items-center justify-center">
                    <OrderStatusIcon />
                    <div className="text-center text-gray-800 text-[15px] font-semibold leading-[27px] tracking-wide mt-2">Смотреть стадию выполнения заказа</div>
                </div>
                <div className="flex flex-col w-[200px] h-[264px] bg-white rounded-lg shadow items-center justify-center">
                    <NewsIcon />
                    <div className="text-center text-gray-800 text-[15px] font-semibold leading-[27px] tracking-wide mt-2">Просматривать актуальные акции <br />и новости химчистки</div>
                </div>
                <div className="flex flex-col w-[200px] h-[264px] bg-white rounded-lg shadow items-center justify-center">
                    <ReviewIcon />
                    <div className="text-center text-gray-800 text-[15px] font-semibold leading-[27px] tracking-wide mt-2">Оставлять отзыв <br />по работе с заказом</div>
                </div>
            </div>
        </SectionLight>

        <SectionLight>
            <div className="mt-10 text-gray-800 text-lg lg:text-xl font-semibold leading-[39px]">Ссылка на заказ имеет общий вид:</div>
            <img className="mt-10 w-fit object-contain" src={Overview} />
            <div className="mt-10 text-gray-800 text-lg lg:text-xl font-semibold leading-[39px]">Как с ней работать?</div>
        </SectionLight>

        <SectionDark>
            <div className="flex text-gray-800 text-md lg:text-lg font-normal leading-9">1. Перейти по ссылке из смс.</div>
        </SectionDark>

        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">2. Проверить корректность общих данных по заказу:</div>
            <div className="flex mt-4">
                <img className="" src={OrderTotal2} />
            </div>
        </SectionLight>

        <SectionDark>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">{'3. Нажать на кнопку "ознакомиться и подтвердить заказ":'}</div>
            <div className="flex mt-4">
                <img className="" src={Confirm3} />
            </div>
        </SectionDark>


        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">4. Далее вы увидите квитанцию по заказу в электронном виде, ознакомьтесь с ней:</div>
            <div className="flex mt-4">
                <img className="" src={Confirm4} />
            </div>
        </SectionLight>

        <SectionDark>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">{'5. По результату ознакомления с квитанций подтвердите заказ, нажав на кнопку "подтвердить заказ":'}</div>
            <div className="flex mt-4">
                <img className="" src={Confirm5} />
            </div>
        </SectionDark>

        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">{'6. Информация о подтверждении отправится в химчистку и ваш заказ примут в работу, заказ сменит свой статус с "неподтвержден" на "новый":'}</div>
            <div className="flex mt-4">
                <img className="" src={Total6} />
            </div>
        </SectionLight>

        <SectionDark>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">7. После этого страница изменит свой вид. Теперь вы можете видеть детали заказа, а именно:<br />- Список услуг заказа<br />- Фото услуг<br />- Статус исполнения услуг</div>
            <div className="flex mt-4">
                <img className="" src={Details7} />
            </div>
        </SectionDark>

        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">{'8. Когда заказ будет полностью готов, он сменит свой статус на "исполненный":'}</div>
            <div className="flex mt-4">
                <img className="" src={Status8} />
            </div>
        </SectionLight>

        <SectionDark>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">9. Кстати, заказ вы можете оплатить на любой удобной для вас стадии: после подтверждения заказа, в процессе исполнения или после него.</div>
        </SectionDark>

        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">{'10. По результату выдачи заказ будет иметь статус "выданный":'}</div>
            <div className="flex mt-4">
                <img className="" src={Status10} />
            </div>
        </SectionLight>

        <SectionDark>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">11. На главной странице по заказу вы можете оставить свой отзыв и поделиться впечатлениями о качестве сервиса химчистки:</div>
            <div className="flex mt-4">
                <img className="" src={Review11} />
            </div>
        </SectionDark>

        <SectionLight>
            <div className="text-gray-800 text-md lg:text-lg font-normal leading-9">12. А также ознакомиться с актуальными её акциями:</div>
            <div className="flex mt-4">
                <img className="" src={Promotions12} />
            </div>
        </SectionLight>

        <SectionLight>
            <div className="text-gray-800 text-lg lg:text-xl font-semibold leading-[39px]">Штрих-код в ссылке на заказ - что это?</div>
            <div className="flex mt-4">
                <img className="" src={Barcode} />
            </div>

            <div className="mt-4 text-gray-800 text-md lg:text-lg font-normal leading-9">Это штрих-код заказа, который можно использовать при получении заказа на приёмном пункте. Показав его сотруднику, он сможет быстро найти заказ.</div>
        </SectionLight>

        <SectionLight>
            <div className="text-gray-800 text-lg lg:text-xl font-semibold leading-[39px]">Какие фото по услугам отображаются?</div>
            <div className="mt-4 text-gray-800 text-md lg:text-lg font-normal leading-9">Отображаются все фото вещей, сделанные во время приёма заказа.</div>
        </SectionLight>

        <SectionLight>
            <div className="text-gray-800 text-lg lg:text-xl font-semibold leading-[39px]">Ссылка мультиязычная?</div>
            <div className="flex mt-4">
                <img className="" src={Language} />
            </div>
            <div className="mt-4 text-gray-800 text-md lg:text-lg font-normal leading-9">Да, при первом открытии она определяет язык системы устройства и если такой перевод есть, то она сразу откроется на этом языке.В дальнейшем его можно поменять сверху, изменения сохранятся и для следующих открытых ссылок.На текущий момент ссылка на заказ переведена на русский, английский, немецкий и украинский языки.</div>
        </SectionLight>

        <SectionDark>
            <div className="text-center text-gray-800 text-lg lg:text-xl font-semibold leading-10">У вас остались вопросы?</div>
            <div className="text-center text-gray-800 text-md lg:text-lg font-normal leading-9">Свяжитесь с химчисткой по телефону расположеному в верхнем правом углу страницы ссылки на заказ</div>
            <div className="flex mt-4">
                <img className="" src={Questions} />
            </div>
        </SectionDark>
    </Section>
);


export default observer(MainPage);
